export default "__VITE_ASSET__DzAgz0i$__"